<template>
  <div>
    <img
      v-if="imgQR === true"
      :src="datosExpedientePdf.pathQR"
      alt="qr"
      width="400"
      height="400"
    />
    <!--Dialog loader -->
    <DialogLoader
      :dialogVisible="dialogLoaderVisible"
      :text="dialogLoaderText"
    ></DialogLoader>
    <!---->
    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    <!-- PDF Content Here -->
    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="`Constancia_Ingreso_Expediente`"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
          <!--@progress="onProgress($event)"-->
          <section slot="pdf-content" class="pdf-content">
            <!-- PDF Content Here -->
            <IngresoExpedientePdf
              :datosExpedientePdf="datosExpedientePdf"
              v-if="montarConstanciaPdf === true"
            />
          </section>
        </vue-html2pdf>
      </div>
    </template>
  </div>

  <!-- Fin:: Snack alert-->
</template>
<script>
import DialogLoader from "@/view/content/DialogLoader";
import SnackAlert from "@/view/content/alerts/SnackAlert.vue";
import VueHtml2pdf from "vue-html2pdf";
import IngresoExpedientePdf from "@/view/components/reportes/IngresoExpedientePdf.vue";
import { OBTENER_EXPEDIENTE_BY_QR } from "@/core/services/store/expedientes/expedientes.module";
export default {
  name: "QRExpediente",
  data() {
    return {
      dialogLoaderVisible: false,
      montarConstanciaPdf: false,
      imgQR: false,
      datosExpedientePdf: {},
      //dialogSuspension: false,
      dialogLoaderText: "Cargando...",
      datosItem: {
        token: "",
      },
      parametros: {},
    };
  },
  components: {
    DialogLoader,
    SnackAlert,
    VueHtml2pdf,
    IngresoExpedientePdf,
  },
  methods: {
    async cargarConstanciaIngreso(token) {
      this.dialogLoaderVisible = true;
      await this.$store
        .dispatch(OBTENER_EXPEDIENTE_BY_QR, token)
        .then((res) => {
          if (res.status === 200) {
            this.datosExpedientePdf = res.data.data;
            if (this.datosExpedientePdf.pathQR) {
              this.datosExpedientePdf.pathQR =
                "data:image/png;base64," + res.data.imgqr;
              this.imgQR = true;
            }
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .then(() => {
          this.montarConstanciaPdf = true;
        })
        .then(() => {
          this.descargarConstanciaIngresoPdf();
        })
        .then(() => {
          this.montarConstanciaPdf = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error.`
          );

          this.dialogLoaderVisible = false;
          this.btnRegistroCobroLoading = false;
          this.btnRegistroCobroVisaLoading = false;
          this.montarConstanciaPdf = false;
        });
    },
    async descargarConstanciaIngresoPdf() {
      await this.$refs.html2Pdf.generatePdf();
    },
  },
  created() {},
  mounted() {
    this.parametros = this.$route.params;
    //console.log(this.parametros);
    if (this.parametros.token) {
      this.datosItem.token = this.parametros.token;
      //console.log(this.parametros.token);
      //this.activarUsuarioProponente();
      this.cargarConstanciaIngreso(this.datosItem.token);
    } else {
      //console.log("nel pastel");
      this.$router.push({ name: "404" });
    }
  },
  computed: {},
};
</script>
<style lang=""></style>
